<script setup>
import YandexMetrika from "@/Layouts/Components/Metrics/YandexMetrika.vue";
</script>

<template>
    <YandexMetrika/>
    <slot/>
</template>

<style scoped>

</style>
